var Image = /** @class */ (function () {
    function Image(url, loading) {
        this.broken = false;
        this.loading = true;
        this.url = url;
        this.loading = loading;
    }
    return Image;
}());
export { Image };
//# sourceMappingURL=image.js.map